import {
  IContentAreaProps,
  IDataContext, IIndicator,
  IMenuButton,
  ISelectedNode,
  IViewController,
  SchemaNodeType
} from "../../types";
import { ReactElement } from "react";
import DeveloperBoardIcon from "@mui/icons-material/DeveloperBoard";
import ViewCompact from "@mui/icons-material/ViewCompact";
import DashboardIcon from "@mui/icons-material/Dashboard";

import LadleStatusPage from "./ladles/ladleStatusPage";
import Tracking from "./ladles/tracking";
import ProductionReportEAF from "./eaf/productionReportEAF";
import ProductionReportLRF from "./lrf/production/productionReportLRF";
import ProductionReportCaster from "./caster/production/productionReportCaster";
import ProductionReport from "./production/productionReport";
import Overview from "./overview";
import DifferentialPressures from "./baghouse/differentialPressures";
import Hmi from "./caster/hmi";
import HmiLab from "./caster/hmiLab";


class Module implements IViewController {

  private ladleStatusButton: IMenuButton = {
    title: "Status",
    icon: <DeveloperBoardIcon/>,
    color: "purple",
    dataContext: {
      title: "Status",
      module: "meltShop",
      subModule: "ladle/ladleStatus"
    }
  };

  private ladleButton: IMenuButton = {
    title: "Ladles",
    icon: <DeveloperBoardIcon/>,
    color: "orange",
    dataContext: {
      title: "Ladles",
      module: "meltShop",
      subModule: "ladle/tracking"
    }
  };

  private ladleDashboardButton: IMenuButton = {
    title: "Dashboard",
    icon: <DeveloperBoardIcon/>,
    color: "cyan",
    disabled: true,
    dataContext: {
      title: "Dashboard",
      module: "meltShop",
      subModule: "ladle/dashboard"
    }
  };

  private ladleGroupButton: IMenuButton = {
    title: "Ladles",
    icon: <DeveloperBoardIcon/>,
    color: "blue",
    children: [this.ladleStatusButton, this.ladleButton, this.ladleDashboardButton],
    dataContext: {
      title: "Ladles",
      module: "meltShop",
      subModule: "ladleGroup"
    }
  };

  private productionEAFButton: IMenuButton = {
    title: "Production",
    icon: <ViewCompact/>,
    color: "green",
    dataContext: {
      title: "Production",
      module: "meltShop",
      subModule: "production/eaf"
    }
  };

  private productionLRFButton: IMenuButton = {
    title: "Production",
    icon: <ViewCompact/>,
    color: "green",
    dataContext: {
      title: "Production",
      module: "meltShop",
      subModule: "production/lrf"
    }
  };

  private productionCasterButton: IMenuButton = {
    title: "Production",
    icon: <ViewCompact/>,
    color: "green",
    dataContext: {
      title: "Production",
      module: "meltShop",
      subModule: "production/caster"
    }
  };

  private productionMeltshopButton: IMenuButton = {
    title: "Production",
    icon: <ViewCompact/>,
    color: "green",
    dataContext: {
      title: "Production",
      module: "meltShop",
      subModule: "production/meltshop"
    }
  };

  private dashboardButton: IMenuButton = {
    title: "Dashboard",
    icon: <DashboardIcon/>,
    color: "cyan",
    disabled: true,
    dataContext: {
      title: "Dashboard",
      module: "meltShop",
      subModule: "production/dashboard"
    }
  };

  private overviewButton: IMenuButton = {
    title: "Overview",
    icon: <DashboardIcon/>,
    color: "cyan",
    disabled: false,
    dataContext: {
      title: "Overview",
      module: "meltShop",
      subModule: "overview"
    }
  };

  private differentialPressuresButton: IMenuButton = {
    title: "Differential Pressures",
    icon: <DashboardIcon/>,
    color: "cyan",
    disabled: false,
    dataContext: {
      title: "Differential Pressures",
      module: "meltShop",
      subModule: "differentialPressures"
    }
  };

  private casterHMIButton: IMenuButton = {
    title: "HMI",
    icon: <DashboardIcon/>,
    color: "cyan",
    disabled: false,
    dataContext: {
      title: "HMI",
      module: "meltShop",
      subModule: "caster/hmi"
    }
  };

  private casterHMILabButton: IMenuButton = {
    title: "HMI - LAB",
    icon: <DashboardIcon/>,
    color: "cyan",
    disabled: false,
    dataContext: {
      title: "HMI - LAB",
      module: "meltShop",
      subModule: "caster/hmi-lab"
    }
  };

  private buttons = [
    this.ladleGroupButton,
    this.ladleStatusButton,
    this.ladleButton,
    this.ladleDashboardButton,
    this.productionEAFButton,
    this.productionLRFButton,
    this.productionCasterButton,
    this.dashboardButton,
    this.productionMeltshopButton,
    this.overviewButton,
    this.differentialPressuresButton,
    this.casterHMIButton,
    this.casterHMILabButton
  ];

  public getModuleName(): string{
    return "meltShop";
  }

  public getView (dataContext: IDataContext, props: IContentAreaProps): ReactElement {
    if (dataContext.subModule === "ladle/tracking") {
      return <Tracking parentSize={props.parentSize} />;
    }

    if (dataContext.subModule === "ladle/ladleStatus") {
      return <LadleStatusPage parentSize={props.parentSize} />;
    }

    if (dataContext.subModule === "production/eaf") {
      return <ProductionReportEAF parentSize={props.parentSize} />;
    }

    if (dataContext.subModule === "production/lrf") {
      return <ProductionReportLRF parentSize={props.parentSize} />;
    }

    if (dataContext.subModule === "production/caster") {
      return <ProductionReportCaster parentSize={props.parentSize} />;
    }

    if (dataContext.subModule === "production/meltshop") {
      return <ProductionReport parentSize={props.parentSize} />;
    }

    if (dataContext.subModule === "overview") {
      return <Overview parentSize={props.parentSize} />;
    }

    if (dataContext.subModule === "differentialPressures") {
      return <DifferentialPressures parentSize={props.parentSize} />;
    }

    if (dataContext.subModule === "caster/hmi") {
      return <Hmi parentSize={props.parentSize} />;
    }

    if (dataContext.subModule === "caster/hmi-lab") {
      return <HmiLab parentSize={props.parentSize} />;
    }

    return <div />;
  }

  getButtons(node: ISelectedNode): IMenuButton[] {
    if (node.type === SchemaNodeType.Area && node.code === "MELTSHOP") {
      return [ this.ladleGroupButton ];
    }

    return [];
  }

  getButton(subModule: string): IMenuButton | undefined {
    return this.buttons.find(x => x.dataContext && x.dataContext.subModule === subModule);
  }

  getIndicator(dataContext: IIndicator): ReactElement | undefined {
    if (dataContext.component === "") {
      return <div />;
    }

    return undefined;
  }
}

const instance = new Module();

export default instance;
